import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from '../QuestionContainer';
import {
  QuestionInputContainer,
  QuestionInputHalfHeight,
  QuestionSubHeading,
} from '../TextQuestion/TextQuestion.styles';

const OTHER_SITE_VALUE = 'Other';

interface Props {
  organisation: string;
  sites: Array<{ name: string }>;
  selectedSiteName: string;
  onSiteSelected(siteName: string): void;
  backLink: string;
  nextLink: string;
  percentage: number;
}

export const SiteQuestion: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const otherLabel = t('public.Site.other');
  const options = [...props.sites, { name: otherLabel }];

  const [selected, setSelected] = React.useState<{ name: string } | null>(
    options.find((s) => s.name === props.selectedSiteName) ?? null,
  );

  return (
    <QuestionContainer
      organisation={props.organisation}
      backLink={props.backLink}
      nextLink={props.nextLink}
      i18nHeader="public.Site.header"
      percentage={props.percentage}
      submitAnswer={() => {
        props.onSiteSelected(
          selected?.name === otherLabel
            ? OTHER_SITE_VALUE
            : (selected?.name ?? ''),
        );
      }}
    >
      <QuestionInputContainer>
        <QuestionInputHalfHeight>
          <QuestionSubHeading>
            {t('public.Site.description')}
          </QuestionSubHeading>
          <Autocomplete
            data-testid="site-autocomplete"
            options={options}
            getOptionLabel={(option) => option.name}
            value={selected}
            onChange={(_event, newValue) => {
              setSelected(newValue);
            }}
            isOptionEqualToValue={(option, value) => option.name === value.name}
            noOptionsText={t('public.Site.noOptions')}
            fullWidth
            renderInput={(params) => (
              <TextField
                {...params}
                data-testid="site-input"
                variant="standard"
                placeholder={t('public.Site.placeholder')}
              />
            )}
          />
        </QuestionInputHalfHeight>
      </QuestionInputContainer>
    </QuestionContainer>
  );
};

export default SiteQuestion;
